"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CasteZadavateleForm_1 = __importDefault(require("../../DruhyOsobField/components/CasteZadavateleForm"));
var PridatCasteZadavatele = function (_a) {
    var isPosudek = _a.isPosudek, addZadavatel = _a.addZadavatel;
    var handleAdd = function (item, form) {
        var newvalue = __assign(__assign({}, item), { typOsoby: item.druhOsoby, adresaPobytu: item.adresa, adresaSidla: item.adresa });
        addZadavatel(newvalue, form);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CasteZadavateleForm_1.default, { onSubmit: handleAdd, labels: {
                search: 'Zadejte jméno, IČO nebo ID datové schránky osoby',
                submit: 'PŘIDAT ZADAVATELE',
            }, isPosudek: isPosudek })));
};
exports.default = PridatCasteZadavatele;
